
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/venafi-alternative",
      function () {
        return require("private-next-pages/compare/venafi-alternative.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/venafi-alternative"])
      });
    }
  